module.exports = __webpack_public_path__ + "img/19a0943.png";